window.addEventListener('load', () => setupFlickity())

function setupFlickity() {
    var elem = document.querySelector('.carousel')
    if (!elem) return
    var flkty = new Flickity(elem, {
        // options
        cellAlign: 'center',
        contain: true,
        wrapAround: true,
        pageDots: false
    })
}
